module.exports = __webpack_public_path__ + "./imgs/bg.jpg?81c8aeeb82f6471e26dc32566c910917";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/culture_nh/bg.jpg
// module id = 90
// module chunks = 19